module.exports = __webpack_public_path__ + "media/assets/images/flags/tz-f45a8b24961ebe9dbcb7fecd38b238c1.svg";